import { NAV_SOLUTIONS, SERVICES } from "./services";
import { INDUSTRIES } from "./industries";
import { CASE_CATEGORIES } from "./caseStudies";

export const PRIMARY_NAV = [
  { label: "Solutions", to: "/solutions", children: NAV_SOLUTIONS.map((s) => ({ label: s.title, to: `/solutions#${s.slug}`, desc: s.intent })) },
  { label: "Services", to: "/services", children: SERVICES.map((s) => ({ label: s.title, to: `/services#${s.slug}`, desc: s.short })) },
  {
    label: "Industries", to: "/industries",
    children: [...INDUSTRIES.map((i) => ({ label: i.title, to: `/industries/${i.slug}`, desc: i.short })), { label: "View All Industries", to: "/industries", desc: "Every vertical we serve." }],
  },
  { label: "Case Studies", to: "/case-studies", children: CASE_CATEGORIES.filter((c) => c !== "All").map((c) => ({ label: c, to: `/case-studies?category=${c}`, desc: `${c} engagements.` })) },
  { label: "Partnership", to: "/partnership" },
  {
    label: "Careers", to: "/careers",
    children: [
      { label: "Open Positions", to: "/careers#positions", desc: "Roles currently open." },
      { label: "Technology Careers", to: "/careers#technology", desc: "Engineering, cloud, data and AI." },
      { label: "Consulting & Recruiting Careers", to: "/careers#consulting", desc: "Advisory and talent roles." },
      { label: "Apply Now", to: "/careers#apply", desc: "Submit your application." },
    ],
  },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_COLUMNS = [
  { title: "Company", links: [{ label: "About", to: "/about" }, { label: "Careers", to: "/careers" }, { label: "Partnership", to: "/partnership" }, { label: "Contact", to: "/contact" }] },
  { title: "Services", links: SERVICES.map((s) => ({ label: s.title, to: `/services#${s.slug}` })) },
  { title: "Industries", links: INDUSTRIES.map((i) => ({ label: i.title.replace(" Staffing", ""), to: `/industries/${i.slug}` })) },
  { title: "Resources", links: [{ label: "Case Studies", to: "/case-studies" }, { label: "Resources", to: "/resources" }, { label: "Insights", to: "/insights" }, { label: "FAQs", to: "/faq" }] },
];

export const SEARCH_INDEX = [
  ...PRIMARY_NAV.flatMap((n) => [{ label: n.label, to: n.to, group: "Pages" }, ...(n.children || []).map((c) => ({ label: c.label, to: c.to, group: n.label }))]),
  { label: "Book a Consultation", to: "/contact", group: "Actions" },
  { label: "Request Staffing", to: "/contact?form=employer", group: "Actions" },
  { label: "Apply as a Candidate", to: "/careers#apply", group: "Actions" },
  { label: "Client Portal", to: "/app", group: "Actions" },
];
